import { Routes, Route } from "react-router-dom";

import "./assets/style.css";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./components/Home";
import About from "./components/About";
import PosterDesign from "./components/PosterDesign";
import CIAImpactReport from "./components/CIAImpactReport";
import Illustrations from "./components/Illustrations";
import SbarroPizza from "./components/SbarroPizza";
import WinterLinkMagazine from "./components/WinterLinkMagazine";
import AlumniExhibition2023 from "./components/AlumniExhibition2023";
import CIABuildingSticker from "./components/CIABuildingSticker";
import AcademyforPuppies from "./components/AcademyforPuppies";
import ParamoreCollage from "./components/ParamoreCollage";
import MCRBlackParade from "./components/MCRBlackParade";
import PanicinVegas from "./components/PanicinVegas";
import IMLOpening from "./components/IMLOpening";

function App() {
  return (
    <>
      <ScrollToTop />

      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/PosterDesign" element={<PosterDesign />} />
          <Route path="/CIAImpactReport" element={<CIAImpactReport />} />
          <Route path="/Illustrations" element={<Illustrations />} />
          <Route path="/SbarroPizza" element={<SbarroPizza />} />
          <Route path="/WinterLinkMagazine" element={<WinterLinkMagazine />} />
          <Route
            path="/AlumniExhibition2023"
            element={<AlumniExhibition2023 />}
          />
          <Route path="/CIABuildingSticker" element={<CIABuildingSticker />} />
          <Route path="/AcademyforPuppies" element={<AcademyforPuppies />} />
          <Route path="/ParamoreCollage" element={<ParamoreCollage />} />
          <Route path="/MCRBlackParade" element={<MCRBlackParade />} />
          <Route path="/PanicinVegas" element={<PanicinVegas />} />
          <Route path="/IMLOpening" element={<IMLOpening />} />
  
        </Routes>
      </Layout>
    </>
  );
}

export default App;
